import { type Stripe } from 'stripe';
import { toValue } from 'vue';
import useCheckout from '~/composables/useCheckout';

export const startTrial = async (
  form: MaybeRef,
  baseUrl: string,
  userId: string,
  customerId: string,
  successUrl: string
) => {
  const { makeCheckoutSession } = useCheckout();
  const metadata = {
    ...toValue(form),
    ...{ stripe_customer_id: customerId },
  } as Omit<Stripe.Metadata, 'password' | 'password_confirm'>;

  // We encountered the following error passing an array into metadata:
  // - "Metadata values must be strings, but for key `sports` you passed in a value of type `hash`. Invalid value: {:\"0\"=>\"Baseball\"}"
  // check if the values are an array, if so, join the array into a string
  for (const key in metadata) {
    if (Array.isArray(metadata[key])) {
      metadata[key] = metadata[key].join(',');
    }
  }

  if ('password' in metadata) delete metadata.password;
  if ('password_confirm' in metadata) delete metadata.password_confirm;

  const req: Stripe.Checkout.SessionCreateParams = {
    customer: customerId,
    // customer_creation: 'always',
    client_reference_id: userId,
    currency: 'usd',
    mode: 'setup',
    metadata,
    setup_intent_data: {
      metadata,
    },
    // subscription_data: {
    //   trial_period_days: 7,
    // },
    success_url: successUrl,
    // return_url: `${baseUrl}/my-account?checkout_action=return`,
    cancel_url: `${baseUrl}/sign-up`,
  };
  console.log(req);
  const { data: checkoutRes, error: checkoutError } = await makeCheckoutSession(req);
  console.log(checkoutRes, checkoutError);
  if (checkoutError.value) throw checkoutError;
  if (checkoutRes.value?.data.url) {
    // navigate to checkout URL checkoutRes.value.data.url in the current browser tab
    window.location.href = checkoutRes.value.data.url;
  } else {
    throw new Error('Failed to start trial');
  }
};
